const NAME = "GEO_QUERY_DEFINITION_PARAMETERS_PAGE";

export default NAME;
